<template>
    <div class="image__slider-lightbox" :class="{active: this.lightbox == true}">
        <div class="lightbox-close" v-on:click="close"><mdb-icon icon="times" size="2x" class="white-text pr-3" /></div>
        <div class="prev-ligthbox lightbox-btn" v-on:click="prev"><mdb-icon icon="chevron-left" size="3x" class="white-text pr-3" /></div>
        <div class="current__image--wrapper-lightbox">
            <img :src="images[index]">
            <div class="current__index">
                <p>Bild {{index +1}} von {{images.length}}</p>
            </div>
        </div>

        <div class="next-ligthbox lightbox-btn" v-on:click="next"><mdb-icon icon="chevron-right" size="3x" class="white-text pr-3" /></div>
    </div>
</template>

<script>
    import { bus } from '@/main';
    export default {
        name: "LightboxMW",
        props: {


        },
        data() {
            return {
                index: 0,
                images: [],
                lightbox: false
            };
        },
        methods: {
            next(){
                if(this.index == this.images.length -1){
                    this.index = 0;
                } else {
                    this.index++;
                }

            },
            prev(){
                if(this.index == 0){
                    this.index = this.images.length -1;
                } else {
                    this.index--;
                }
            },
            close(){
                this.lightbox = false;
                this.index = 0;
            }
        },
        created (){
            bus.$on('openLightbox', (data) => {
                this.images = data;
                this.index = 0;
                this.lightbox = true;
            })
        },

    }
</script>

<style scoped lang="scss">
    .image__slider-lightbox{
        position: fixed;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.75);
        z-index: 9999;
        display: flex;
        justify-content: center;
        align-items: center;
        opacity: 0;
        visibility: hidden;
        pointer-events: none;
        transition: 0.4s ease;
        &.active{
            opacity: 1;
            visibility: visible;
            pointer-events: all;
        }
        .lightbox-btn{
            position: absolute;
            top: 50%;
            cursor: pointer;
            &.prev-ligthbox{
                left: 15px;
            }
            &.next-ligthbox{
                right: 15px;
            }
        }
        .lightbox-close{
            position: absolute;
            right: 20px;
            top: 20px;
            cursor: pointer;
        }
        .current__image--wrapper-lightbox{
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            .current__index{
                background-color: black;
                padding: 10px 20px;
                //width: 75%;
                width: 100%;
                text-align: center;
                display: flex;
                justify-content: center;
                align-items: center;
                p{
                    color: white;
                    margin-bottom: 0px;
                }
            }
            img{
                //max-width: 75%;
                //max-height: 80%;
                max-width: 75vw;
                max-height: 80vh;
                width: auto;
                height: auto;
            }
        }

    }
</style>